module.exports = __webpack_public_path__ + "assets/spoonretractors.57eeab12aa2ef9297f932fbf32b164ae.jpg";